import(/* webpackMode: "eager" */ "/vercel/path0/apps/parrot/app/loading.tsx");
